// extracted by mini-css-extract-plugin
export var cardHeader = "_ji-1";
export var contentCard = "_ji-0";
export var headerActions = "_ji-3";
export var reorderHandle = "_ji-5";
export var titleArea = "_ji-2";
export var titleAreaWithHandle = "_ji-4";